/**
 * Sticky Slider Component
 * @module patterns/components/sticky-slider
 */

import { App } from '~/app';
import { mountVerticalCarousel } from '~/patterns/components/carousels/vertical-carousel/vertical-carousel';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Sticky Slider Component');

    const listeners: Array<[Document | Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountVerticalCarousel(listeners, '.sticky-slider', 'active-text-indicator');
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Sticky Slider Component', error);
        });

    return function destroyVerticalScrollCarousel() {
        unMountVerticalScrollCarousel(listeners);

        app.logger.debug('[DXA] Sticky Slider Component destroyed');
    };
};


export function unMountVerticalScrollCarousel(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
